import { Button, CTA, Reveal, useSeo } from "../components/Shared";
import { IMG } from "../data/content";

export default function Founder() {
  useSeo(
    "Arnav Das, Founder | Dishan International Group",
    "Arnav Das, Founder, Chairman & Managing Director of Dishan International Group, strategic brand architect and business growth consultant."
  );
  return (
    <>
      <section className="page-hero">
        <div className="container">
          <Reveal>
            <span className="eyebrow">Leadership</span>
            <h1>The person behind the point of view.</h1>
            <p>A founder-led ecosystem shaped by strategic brand thinking, business growth and an enduring interest in human potential.</p>
          </Reveal>
        </div>
      </section>
      <main>
        <section className="section">
          <div className="container founder-page">
            <Reveal className="founder-media"><img src={IMG.founder} alt="Arnav Das portrait" /></Reveal>
            <Reveal delay={0.1}>
              <span className="eyebrow">Arnav Das</span>
              <h2>Founder, Chairman & Managing Director</h2>
              <p className="role-list">Chief Branding Officer · Strategic Brand Architect · Business Growth Consultant</p>
              <p>Arnav works across business, branding, marketing, leadership, awareness and human capability. His practice is grounded in a simple belief: when people understand what matters, they can make better decisions about what comes next.</p>
              <p>He is also a Neuro-Strategic Business Consultant, Marketing Advisor, OSOB Researcher, Awareness Creator and Keynote Speaker.</p>
              <Button>Connect with Arnav</Button>
            </Reveal>
          </div>
        </section>
        <section className="section mist">
          <div className="container quote">
            <Reveal>
              <span className="eyebrow">Professional philosophy</span>
              <blockquote>“Think positive. Be realistic. Then build something worth believing in.”</blockquote>
              <p>Thought leadership · Speaking · Consulting · Articles · Media</p>
            </Reveal>
          </div>
        </section>
        <CTA />
      </main>
    </>
  );
}
